export default __webpack_public_path__ + "static/media/image22.3929e937.png";